'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('simple-line-icons/css/simple-line-icons.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var fontSize = function fontSize(size) {
  if (size.toLowerCase() === 'large') {
    return '22pt';
  } else if (size.toLowerCase() === 'small') {
    return '8pt';
  }
  return '18px';
};

var SimpleLineIcon = function SimpleLineIcon(_ref) {
  var name = _ref.name,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ['name', 'color', 'size', 'style']);

  return _react2.default.createElement('div', _extends({
    className: 'icon-' + name,
    style: _extends({
      color: color,
      fontSize: fontSize(size)
    }, style)
  }, rest));
};

SimpleLineIcon.propTypes = {
  name: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['Large', 'large', 'Medium', 'medium', 'Small', 'small']),
  style: _propTypes2.default.object
};

SimpleLineIcon.defaultProps = {
  color: null,
  size: 'Medium',
  style: {}
};

exports.default = SimpleLineIcon;


//////////////////
// WEBPACK FOOTER
// ./~/react-simple-line-icons/dist/index.js
// module id = ./node_modules/react-simple-line-icons/dist/index.js
// module chunks = 2345137460201621000